<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
    <div class="container">
        <div class="section">
            <mat-form-field appearance="outline" class="search-bar" [formGroup]="PatDegradeForm">
                <mat-label>Rechercher un patient existant ou saisir les informations patient...</mat-label>
                <input #searchInput matInput formControlName="searchCtrl" [matAutocomplete]="auto" (keydown.enter)="$event.preventDefault()">
                <!-- Suffixe : flèche pour ouvrir les récents -->
                <button mat-icon-button matSuffix aria-label="Patients récents"
                  (mousedown)="$event.preventDefault()" (click)="openRecents()">
                  <mat-icon>expand_more</mat-icon>
                </button>
            </mat-form-field>
            <mat-autocomplete #auto="matAutocomplete"
                [displayWith]="displayPatient" (optionSelected)="onPatientSelected($event.option.value)">
                <mat-option *ngFor="let p of patientsList" [value]="p">
                  <div class="patient-option">
                    <!-- <div class="title" *ngIf="patientVu">{{p}}</div> -->
                    <div class="title" >{{ p.nomUsage || p.nomNaissance || '' }}, {{ p.nomPrenomDateNaissance }}</div>
                    <div class="meta" *ngIf="p.numSecSociale">{{ p.numSecSociale }}</div>
                  </div>
                </mat-option>
                <mat-option *ngIf="!loading && (patientsList?.length || 0) === 0 && PatDegradeForm.get('search')?.value">
                  Aucun résultat
                </mat-option>
            </mat-autocomplete>
        </div>

          <!-- Affichage du choix -->
          <div *ngIf="SearchidPatient" class="mt-2">
            Patient sélectionné : {{ SearchPatientNom}}
            <!-- ID sélectionné : {{ SearchidPatient }} -->
          </div>
        <form *ngIf="PatDegradeForm" [formGroup]="PatDegradeForm">
            <!-- Bénéficiaire -->

            <div class="zone beneficiaire">

                <p class="section-title">Renseignement bénéficiaire</p>
                <div class="section-nombenef">
                    <mat-form-field >
                        <mat-label>Nom bénéficiaire</mat-label>
                        <input matInput formControlName="nom_benef" (blur)="doUppercaseInputValue(PatDegradeForm.get('nom_benef'))">
                        <mat-error *ngIf="PatDegradeForm.get('nom_benef')?.hasError('required')">Ce champ est obligatoire.</mat-error>
                    </mat-form-field>

                    <mat-form-field >
                        <mat-label>Prénom bénéficiaire</mat-label>
                        <input matInput formControlName="prenom_benef" (blur)="doUppercaseInputValue(PatDegradeForm.get('prenom_benef'))">
                        <mat-error *ngIf="PatDegradeForm.get('prenom_benef')?.hasError('required')">Ce champ est obligatoire.</mat-error>
                    </mat-form-field>
                </div>

                <div class="section-datebenef">
                    <!-- <mat-form-field class="date_benef">
                        <mat-label >Date de naissance *</mat-label>
                        <input matInput [matDatepicker]="pickerBenef" formControlName="date_benef">
                        <mat-datepicker-toggle matSuffix [for]="pickerBenef"></mat-datepicker-toggle>
                        <mat-datepicker #pickerBenef></mat-datepicker>
                    </mat-form-field> -->
                    <mat-form-field class="date_benef">
                        <mat-label>{{ dateNaissBenef }}</mat-label>
                        <input matInput
                               formControlName="date_benef"
                               placeholder="JJ/MM/AAAA"
                               maxlength="10"
                               (blur)="formatterDateBenef()" />
                      </mat-form-field>

                    <mat-form-field class="rang_benef">
                        <mat-label >Rang *</mat-label>
                        <input matInput type="number" formControlName="rang_benef">
                    </mat-form-field>

                    <mat-form-field class="qualite_benef">
                        <mat-label >Qualité *</mat-label>
                        <mat-select formControlName="qualite_benef">
                            <mat-option *ngFor="let q of qualites" [value]="q.code">{{ q.code+' - '+q.libelle }}</mat-option>
                            <!-- <mat-option *ngFor="let q of qualite" [value]="q.id">{{ q.libelle }}</mat-option> -->

                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Assuré -->
            <div *ngIf="PatDegradeForm?.get('assureGroup') && PatDegradeForm?.get('assureGroup')?.enabled" formGroupName="assureGroup">
                <div class="zone assure">
                    <p class="section-title" [style.color]="PatDegradeForm.get('assureGroup')?.errors?.assureIncomplete ? 'red' : 'inherit'">
                        {{ PatDegradeForm.get('assureGroup')?.errors?.assureIncomplete
                            ? 'Tous les champs Assuré doivent être remplis.'
                            : 'Assuré' }}
                    </p>

                    <div class="section">
                        <mat-form-field >
                            <mat-label>Nom assuré</mat-label>
                            <input matInput formControlName="nom_assure" (blur)="doUppercaseInputValue(PatDegradeForm.get('assureGroup.nom_assure'))">
                        </mat-form-field>

                        <mat-form-field >
                            <mat-label>Prénom assuré</mat-label>
                            <input matInput formControlName="prenom_assure" (blur)="doUppercaseInputValue(PatDegradeForm.get('assureGroup.prenom_assure'))">
                        </mat-form-field>
                    </div>

                    <div class="section">
                        <mat-form-field >
                            <mat-label>Date de naissance</mat-label>
                            <input matInput [matDatepicker]="pickerAssure" formControlName="date_assure">
                            <mat-datepicker-toggle matSuffix [for]="pickerAssure"></mat-datepicker-toggle>
                            <mat-datepicker #pickerAssure></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field >
                            <mat-label>Rang gémellaire</mat-label>
                            <input matInput type="number" formControlName="rang_assure">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Renseignements médico-administratifs -->
            <div class="zone admin">
                <p class="section-title">Renseignements médico-administratifs</p>
                <div class="section-NIR">
                    <mat-form-field class="NIR">
                        <mat-label >NIR assuré *</mat-label>
                        <input matInput formControlName="NIR_assure" (input)="onNirChange($event.target.value)" maxlength="13">
                        <mat-error *ngIf="PatDegradeForm.get('NIR_assure')?.hasError('required')">Le NIR est obligatoire.</mat-error>
                        <mat-hint *ngIf="!nirInvalide">13 car.</mat-hint>
                    </mat-form-field>
                    <mat-form-field class="NIR-cle">
                        <mat-label >Clé *</mat-label>
                        <input matInput formControlName="Cle_assure" maxlength="2" (input)="onCleChange($event.target.value)">
                    </mat-form-field>
                    <mat-form-field class="codeRegime">
                        <mat-label >Grand Régime *</mat-label>
                        <mat-select formControlName="codeRegime">
                            <mat-option *ngFor="let r of regimes" [value]="r.code" matTooltip="{{ r.libelle }}">{{ r.code+' - '+r.libelle }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- <mat-form-field class="codeCaisse">
                        <mat-label>Caisse gestion</mat-label>
                        <input matInput formControlName="codeCaisse"[disabled]="!PatDegradeForm.get('NIR_assure').value">
                        <mat-hint>3 car.</mat-hint>
                    </mat-form-field>
                    <mat-form-field class="codeCentre">
                        <mat-label>Centre gestion</mat-label>
                        <input matInput formControlName="codeCentre" [disabled]="!PatDegradeForm.get('NIR_assure').value">
                        <mat-hint>4 car.</mat-hint>
                    </mat-form-field> -->
                </div>

                <!-- <div class="section">
                    <mat-form-field class="codeRegime">
                        <mat-label>Grand Régime</mat-label>
                        <mat-select formControlName="codeRegime">
                            <mat-option *ngFor="let r of regimes" [value]="r.code" matTooltip="{{ r.libelle }}">{{ r.code+' - '+r.libelle }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div> -->
                <div class="section">
                    <mat-form-field class="codeRegime">
                        <mat-label >Caisse en gestion *</mat-label>
                        <mat-select [formControl]="ControlOrganismes">
                            <mat-option *ngFor="let org of ListeOrganismes" [value]="org" [matTooltip]="displayOrganismes(org)"
                             matTooltipClass="custom-tooltip">
                                {{ org.codeCaisse+' - '+org.nomCaisse }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="section">
                    <mat-form-field class="codeGestion">
                        <mat-label >code gestion * (si connu)</mat-label>
                        <mat-select formControlName="codeGestion">
                            <mat-option *ngFor="let cg of filteredCodeGestions" [value]="cg.code" matTooltip="{{ cg.libelle }}"
                            matTooltipPosition="right">
                                {{ cg.code + ' - ' + cg.libelle }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="codeSituation">
                        <mat-label >situation du patient * (si connu)</mat-label>
                        <mat-select formControlName="codeSituation" panelClass="custom-select-panel">
                            <mat-option *ngFor="let cs of ListeCodeSituation" [value]="cs.code" matTooltip="{{ cs.libelle }}">
                                {{ cs.code + ' - ' + cs.libelle }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
</mat-dialog-content>
<div class="degrade-footer">
    <form *ngIf="PatDegradeForm" [formGroup]="PatDegradeForm">
        <mat-checkbox color="primary" formControlName="alsaceMoselle" id="alsaceMoselle">
            Régime Local Alsace-Moselle
        </mat-checkbox>
    </form>
    <mat-dialog-actions align="end">
        <button mat-raised-button (click)="close()">Annuler</button>
        <button color="primary" mat-raised-button (click)="onSubmitCouverture()">Valider</button>
    </mat-dialog-actions>
</div>

